import {setCacheNameDetails as workbox_core_setCacheNameDetails} from 'c:/jenkins/workspace/Client_Windows_build/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'c:/jenkins/workspace/Client_Windows_build/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "incredibuild"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/colors.js",
    "revision": "d9493a9e7e5a2ae18cca246685487f69"
  },
  {
    "url": "/config.json",
    "revision": "df115d309bc2c9ecb223db4d15db48e1"
  },
  {
    "url": "/css/1011.6093bb50.css",
    "revision": null
  },
  {
    "url": "/css/1723.704b280d.css",
    "revision": null
  },
  {
    "url": "/css/178.5f913be5.css",
    "revision": null
  },
  {
    "url": "/css/2006.90771911.css",
    "revision": null
  },
  {
    "url": "/css/2335.7c3a7f8e.css",
    "revision": null
  },
  {
    "url": "/css/2641.962e2187.css",
    "revision": null
  },
  {
    "url": "/css/2761.225958cf.css",
    "revision": null
  },
  {
    "url": "/css/3188.84523992.css",
    "revision": null
  },
  {
    "url": "/css/3518.a799a679.css",
    "revision": null
  },
  {
    "url": "/css/3817.bf4c131b.css",
    "revision": null
  },
  {
    "url": "/css/39.94296c17.css",
    "revision": null
  },
  {
    "url": "/css/4294.80d3f691.css",
    "revision": null
  },
  {
    "url": "/css/4579.119faf0b.css",
    "revision": null
  },
  {
    "url": "/css/4639.28fec501.css",
    "revision": null
  },
  {
    "url": "/css/4943.dddf99f3.css",
    "revision": null
  },
  {
    "url": "/css/5668.97dfcdd5.css",
    "revision": null
  },
  {
    "url": "/css/6035.dcb8711d.css",
    "revision": null
  },
  {
    "url": "/css/6438.84919b82.css",
    "revision": null
  },
  {
    "url": "/css/6451.7a31f582.css",
    "revision": null
  },
  {
    "url": "/css/684.996765df.css",
    "revision": null
  },
  {
    "url": "/css/7114.5075f5ef.css",
    "revision": null
  },
  {
    "url": "/css/7324.b58bc447.css",
    "revision": null
  },
  {
    "url": "/css/7353.2d7174b3.css",
    "revision": null
  },
  {
    "url": "/css/7420.30a04262.css",
    "revision": null
  },
  {
    "url": "/css/7759.890bb797.css",
    "revision": null
  },
  {
    "url": "/css/8134.4da70852.css",
    "revision": null
  },
  {
    "url": "/css/8609.637fd9de.css",
    "revision": null
  },
  {
    "url": "/css/8617.26267278.css",
    "revision": null
  },
  {
    "url": "/css/8815.acde1abf.css",
    "revision": null
  },
  {
    "url": "/css/9045.2bf509fa.css",
    "revision": null
  },
  {
    "url": "/css/9341.82c6dac7.css",
    "revision": null
  },
  {
    "url": "/css/9949.ce3d2517.css",
    "revision": null
  },
  {
    "url": "/css/9985.4fe6fcfc.css",
    "revision": null
  },
  {
    "url": "/elementIds.js",
    "revision": "bf30b7266099f5ed3f6e945934a9ca4f"
  },
  {
    "url": "/fonts/Poppins-Bold.8001a01b.ttf",
    "revision": null
  },
  {
    "url": "/fonts/Poppins-Regular.4b4ebe20.ttf",
    "revision": null
  },
  {
    "url": "/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNa.4ad034d2.woff",
    "revision": null
  },
  {
    "url": "/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.9d7f970f.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.04af2357.04af2357.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.04af2357.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.10e88322.10e88322.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.10e88322.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.121b2d67.121b2d67.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.121b2d67.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.1e709b44.1e709b44.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.1e709b44.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.28ecbc72.28ecbc72.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.28ecbc72.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.3e50d5f5.3e50d5f5.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.3e50d5f5.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.501e51cf.501e51cf.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.501e51cf.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.51e9c6ec.51e9c6ec.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.51e9c6ec.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.53ced5cf.53ced5cf.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.53ced5cf.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.5dc46343.5dc46343.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.5dc46343.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.6009a0cd.6009a0cd.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.6009a0cd.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.63c1b679.63c1b679.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.63c1b679.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.779d9359.779d9359.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.779d9359.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.812e411a.812e411a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.812e411a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.9b88ea7f.9b88ea7f.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.9b88ea7f.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.a020bc1a.a020bc1a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.a020bc1a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.a7571c66.a7571c66.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.a7571c66.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.ab9b352d.ab9b352d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.ab9b352d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.acae6b30.acae6b30.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.acae6b30.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.b4daca2f.b4daca2f.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.b4daca2f.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.b72cfe46.b72cfe46.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.b72cfe46.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.ba16f4d3.ba16f4d3.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.ba16f4d3.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.c428faae.c428faae.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.c428faae.woff2",
    "revision": null
  },
  {
    "url": "/fonts/font.d008fe5c.d008fe5c.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.d008fe5c.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.d201540d.d201540d.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.d201540d.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.d56dea16.d56dea16.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.d56dea16.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.e75a4f5e.e75a4f5e.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.e75a4f5e.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.f545ccb8.f545ccb8.woff",
    "revision": null
  },
  {
    "url": "/fonts/font.f545ccb8.woff",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.583097e1.583097e1.eot",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.583097e1.eot",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.9575555c.9575555c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.9575555c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.e9d0767d.e9d0767d.woff",
    "revision": null
  },
  {
    "url": "/fonts/icomoon.e9d0767d.woff",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.035d570c.woff2",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.0e082d31.eot",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.6032aa63.6032aa63.ttf",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.732bf446.woff",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.be5cb4fb.be5cb4fb.eot",
    "revision": null
  },
  {
    "url": "/fonts/incredicon.f0566c68.ttf",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.eb6b7a12.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.1a4ab405.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.0ab280bf.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.a105bfb2.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.0eca4fd7.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.be8bca69.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.5cb78113.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.5db11f4d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.776f40af.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.7454a641.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.75efa0ed.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.e9142c09.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.45b31852.woff2",
    "revision": null
  },
  {
    "url": "/fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.2e6255a3.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.72bdd4c6.72bdd4c6.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.72bdd4c6.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.8465caa7.8465caa7.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.8465caa7.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.b131f1b6.b131f1b6.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.b131f1b6.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.cfe2c6fc.cfe2c6fc.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.cfe2c6fc.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.d53961ca.d53961ca.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.d53961ca.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.db6b7b4e.db6b7b4e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.db6b7b4e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.dec8fb39.dec8fb39.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.dec8fb39.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.e2d00b9b.e2d00b9b.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-0.e2d00b9b.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.1fda43bc.1fda43bc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.1fda43bc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.4ccc2f47.4ccc2f47.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.4ccc2f47.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.64b9e373.64b9e373.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.64b9e373.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.6a4a5045.6a4a5045.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.6a4a5045.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.8abaccf9.8abaccf9.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.8abaccf9.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.c28a6230.c28a6230.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.c28a6230.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.c914ebbb.c914ebbb.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.c914ebbb.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.fd52f41e.fd52f41e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-1.fd52f41e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.29eb1365.29eb1365.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.29eb1365.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.3fe15582.3fe15582.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.3fe15582.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.42fe597f.42fe597f.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.42fe597f.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.488b0ba9.488b0ba9.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.488b0ba9.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.69824dd3.69824dd3.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.69824dd3.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.8eb9696c.8eb9696c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.8eb9696c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.bac13702.bac13702.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.bac13702.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.cff4dbfc.cff4dbfc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-10.cff4dbfc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.10f178a6.10f178a6.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.10f178a6.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.280c2e78.280c2e78.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.280c2e78.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.47c4e17d.47c4e17d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.47c4e17d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.55d5de21.55d5de21.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.55d5de21.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.73923b00.73923b00.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.73923b00.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.854eeb43.854eeb43.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.854eeb43.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.ba1ef1a5.ba1ef1a5.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.ba1ef1a5.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.de04ae15.de04ae15.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-11.de04ae15.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.03c72e07.03c72e07.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.03c72e07.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.04d24300.04d24300.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.04d24300.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.11ceb0c2.11ceb0c2.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.11ceb0c2.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.4b8320f9.4b8320f9.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.4b8320f9.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.60158efa.60158efa.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.60158efa.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.75ae5004.75ae5004.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.75ae5004.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.b5c4247c.b5c4247c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.b5c4247c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.dd93963e.dd93963e.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-12.dd93963e.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.1e74d1d8.1e74d1d8.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.1e74d1d8.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.322cd948.322cd948.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.322cd948.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.578cfb8b.578cfb8b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.578cfb8b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.6cde6ea6.6cde6ea6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.6cde6ea6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.836a1bbe.836a1bbe.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.836a1bbe.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.9edd6680.9edd6680.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.9edd6680.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.a6bba95d.a6bba95d.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.a6bba95d.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.f20a6563.f20a6563.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-13.f20a6563.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.04b2e272.04b2e272.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.04b2e272.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.0c4d6df3.0c4d6df3.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.0c4d6df3.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.11556b3c.11556b3c.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.11556b3c.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.3f3ba8ef.3f3ba8ef.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.3f3ba8ef.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.7cb38658.7cb38658.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.7cb38658.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.b5fcd903.b5fcd903.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.b5fcd903.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.c347505a.c347505a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.c347505a.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.d136e3ec.d136e3ec.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-14.d136e3ec.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.20472969.20472969.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.20472969.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.2c82424a.2c82424a.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.2c82424a.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.2c88a611.2c88a611.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.2c88a611.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.413858be.413858be.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.413858be.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.94b8313c.94b8313c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.94b8313c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.b160edfc.b160edfc.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.b160edfc.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.dfcd26b6.dfcd26b6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.dfcd26b6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.e115649e.e115649e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-15.e115649e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.23854bf0.23854bf0.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.23854bf0.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.47029e84.47029e84.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.47029e84.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.4da8e964.4da8e964.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.4da8e964.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.7e99b2a3.7e99b2a3.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.7e99b2a3.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.8397f053.8397f053.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.8397f053.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.8f943113.8f943113.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.8f943113.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.cb43c8e6.cb43c8e6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.cb43c8e6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.f7af43fe.f7af43fe.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-16.f7af43fe.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.0652b95c.0652b95c.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.0652b95c.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.71f848c5.71f848c5.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.71f848c5.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.7c114848.7c114848.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.7c114848.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.9a0c29b4.9a0c29b4.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.9a0c29b4.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.ad5f1d73.ad5f1d73.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.ad5f1d73.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.c2244e7c.c2244e7c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.c2244e7c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.c9db8aaa.c9db8aaa.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.c9db8aaa.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.d09bbedc.d09bbedc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-17.d09bbedc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.37204d3b.37204d3b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.37204d3b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.77a5b9a0.77a5b9a0.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.77a5b9a0.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.961be83e.961be83e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.961be83e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.a39158c1.a39158c1.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.a39158c1.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.a6e63d93.a6e63d93.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.a6e63d93.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.c77ec2f6.c77ec2f6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.c77ec2f6.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.d8995147.d8995147.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.d8995147.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.f5c9159d.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-18.f5c9159d.f5c9159d.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.2e39d19d.2e39d19d.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.2e39d19d.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.3be312e8.3be312e8.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.3be312e8.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.d121509d.d121509d.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.d121509d.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.d43582fe.d43582fe.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-19.d43582fe.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.0e72066b.0e72066b.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.0e72066b.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.39d3050b.39d3050b.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.39d3050b.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.3f170f4b.3f170f4b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.3f170f4b.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.58ebd953.58ebd953.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.58ebd953.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.bac0a677.bac0a677.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.bac0a677.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.c5f4389b.c5f4389b.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.c5f4389b.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.e03d9454.e03d9454.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.e03d9454.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.f95669dd.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-2.f95669dd.f95669dd.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.0341f416.0341f416.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.0341f416.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.21fbafb3.21fbafb3.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.21fbafb3.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.42d7c6f7.42d7c6f7.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.42d7c6f7.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.6612ab3e.6612ab3e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.6612ab3e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.843f9a51.843f9a51.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.843f9a51.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.88d7906e.88d7906e.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.88d7906e.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.d763557e.d763557e.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.d763557e.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.e9258e69.e9258e69.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-3.e9258e69.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.4dff09f1.4dff09f1.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.4dff09f1.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.59a07093.59a07093.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.59a07093.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.7ab0e95c.7ab0e95c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.7ab0e95c.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.81203ee0.81203ee0.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.81203ee0.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.9c227eba.9c227eba.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.9c227eba.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.e4ea15cb.e4ea15cb.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.e4ea15cb.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.f082bb11.f082bb11.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.f082bb11.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.f6c61551.f6c61551.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-4.f6c61551.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.1a31395e.1a31395e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.1a31395e.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.34809552.34809552.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.34809552.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.3b929322.3b929322.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.3b929322.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.8a3da686.8a3da686.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.8a3da686.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ab103b38.ab103b38.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ab103b38.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ac964292.ac964292.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ac964292.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.c26b7884.c26b7884.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.c26b7884.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ebb9822b.ebb9822b.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-5.ebb9822b.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.0f1b1fdf.0f1b1fdf.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.0f1b1fdf.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.25794dfc.25794dfc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.25794dfc.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.44585cbe.44585cbe.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.44585cbe.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.4ee7f259.4ee7f259.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.4ee7f259.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.70ddda0c.70ddda0c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.70ddda0c.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.aa50af80.aa50af80.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.aa50af80.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.f6708eca.f6708eca.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.f6708eca.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.fd01d4b4.fd01d4b4.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-6.fd01d4b4.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.0c461d97.0c461d97.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.0c461d97.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.1c1f19b2.1c1f19b2.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.1c1f19b2.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.1e192912.1e192912.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.1e192912.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.2253820d.2253820d.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.2253820d.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.3c44aa2c.3c44aa2c.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.3c44aa2c.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.48869000.48869000.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.48869000.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.5d31f1e5.5d31f1e5.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.5d31f1e5.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.9a1df30a.9a1df30a.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-7.9a1df30a.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.06f1bb83.06f1bb83.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.06f1bb83.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.073d33f6.073d33f6.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.073d33f6.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.0bce7d65.0bce7d65.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.0bce7d65.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.0c05991e.0c05991e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.0c05991e.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.2de73c51.2de73c51.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.2de73c51.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.31be9473.31be9473.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.31be9473.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.39dcb6f9.39dcb6f9.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.39dcb6f9.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.9d795f4d.9d795f4d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-8.9d795f4d.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.665552fa.665552fa.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.665552fa.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.7c578bd3.7c578bd3.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.7c578bd3.ttf",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.7fdc3bbd.7fdc3bbd.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.7fdc3bbd.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.898dc92f.898dc92f.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.898dc92f.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.d68dc59e.d68dc59e.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.d68dc59e.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.f3f131a5.f3f131a5.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.f3f131a5.woff2",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.f8950655.f8950655.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.f8950655.woff",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.fb6a46e8.eot",
    "revision": null
  },
  {
    "url": "/fonts/unicons-9.fb6a46e8.fb6a46e8.eot",
    "revision": null
  },
  {
    "url": "/img/Daily_Cores_Usage.4c1fe921.png",
    "revision": null
  },
  {
    "url": "/img/DialogErrorIcon.46389836.svg",
    "revision": null
  },
  {
    "url": "/img/DialogSuccessIcon.150a1aaf.svg",
    "revision": null
  },
  {
    "url": "/img/DialogWarningIcon.4a74fd66.svg",
    "revision": null
  },
  {
    "url": "/img/Log_in_BG.03b3c99d.svg",
    "revision": null
  },
  {
    "url": "/img/Log_in_BG_red.14fd2e60.svg",
    "revision": null
  },
  {
    "url": "/img/Login_Logo.39d59cb3.svg",
    "revision": null
  },
  {
    "url": "/img/Login_Logo_lines.2c2a0538.svg",
    "revision": null
  },
  {
    "url": "/img/Login_Logo_lines_red.a50375e1.svg",
    "revision": null
  },
  {
    "url": "/img/Tier_Free.a4c72eab.svg",
    "revision": null
  },
  {
    "url": "/img/Tier_Pro_proplus.613d229f.svg",
    "revision": null
  },
  {
    "url": "/img/about-tobe-expired-notification.57d71296.svg",
    "revision": null
  },
  {
    "url": "/img/action_not_allowed.2e9cba0b.svg",
    "revision": null
  },
  {
    "url": "/img/api-access.7f69d145.svg",
    "revision": null
  },
  {
    "url": "/img/azureLogoMaterial.7ba32a63.svg",
    "revision": null
  },
  {
    "url": "/img/azure_logo.ced31cd3.svg",
    "revision": null
  },
  {
    "url": "/img/cloud-trial.27f06556.svg",
    "revision": null
  },
  {
    "url": "/img/diagbg.1017d888.png",
    "revision": null
  },
  {
    "url": "/img/diagram.6899cab1.png",
    "revision": null
  },
  {
    "url": "/img/empty_search.ac2acbe0.svg",
    "revision": null
  },
  {
    "url": "/img/filters-logo.afeb4a85.svg",
    "revision": null
  },
  {
    "url": "/img/header_bell.b6520f78.svg",
    "revision": null
  },
  {
    "url": "/img/header_cloud.b7d069aa.svg",
    "revision": null
  },
  {
    "url": "/img/header_cloud_disable.ea427fe4.svg",
    "revision": null
  },
  {
    "url": "/img/icomoon.3b86271e.3b86271e.svg",
    "revision": null
  },
  {
    "url": "/img/icomoon.c5fe6c4f.svg",
    "revision": null
  },
  {
    "url": "/img/incredibuild_logo_start.7545b0bc.svg",
    "revision": null
  },
  {
    "url": "/img/incredicon.22a413dc.svg",
    "revision": null
  },
  {
    "url": "/img/incredicon.640f37b0.640f37b0.svg",
    "revision": null
  },
  {
    "url": "/img/license-error-icon.422e5f25.svg",
    "revision": null
  },
  {
    "url": "/img/license-exclamation-icon.be0f6752.svg",
    "revision": null
  },
  {
    "url": "/img/license-locked-icon.48567a81.svg",
    "revision": null
  },
  {
    "url": "/img/license-question-icon.eedc16c9.svg",
    "revision": null
  },
  {
    "url": "/img/logo-small.eb2eac8c.svg",
    "revision": null
  },
  {
    "url": "/img/logo.496e4366.svg",
    "revision": null
  },
  {
    "url": "/img/logo.ba97110d.svg",
    "revision": null
  },
  {
    "url": "/img/nav_agent_list.ad413733.svg",
    "revision": null
  },
  {
    "url": "/img/nav_agent_list_selected.c11dbb3d.svg",
    "revision": null
  },
  {
    "url": "/img/nav_builds.a478f229.svg",
    "revision": null
  },
  {
    "url": "/img/nav_builds_selected.b430f1d0.svg",
    "revision": null
  },
  {
    "url": "/img/nav_dashboard.d5f8c859.svg",
    "revision": null
  },
  {
    "url": "/img/nav_dashboard_selected.b07c9137.svg",
    "revision": null
  },
  {
    "url": "/img/nav_getting_started.0224ff4b.svg",
    "revision": null
  },
  {
    "url": "/img/nav_getting_started_selected.a50eb054.svg",
    "revision": null
  },
  {
    "url": "/img/nav_help.64fb46ce.svg",
    "revision": null
  },
  {
    "url": "/img/nav_help_selected.24d31713.svg",
    "revision": null
  },
  {
    "url": "/img/nav_license.cee99d1d.svg",
    "revision": null
  },
  {
    "url": "/img/nav_license_selected.1c60b158.svg",
    "revision": null
  },
  {
    "url": "/img/nav_settings.b95374e3.svg",
    "revision": null
  },
  {
    "url": "/img/nav_settings_selected.086a2b40.svg",
    "revision": null
  },
  {
    "url": "/img/nav_user_info_profile.00885495.svg",
    "revision": null
  },
  {
    "url": "/img/nav_user_info_profile_selected.e3cbd383.svg",
    "revision": null
  },
  {
    "url": "/img/nav_users.6bb6124c.svg",
    "revision": null
  },
  {
    "url": "/img/nav_users_selected.037d55d3.svg",
    "revision": null
  },
  {
    "url": "/img/new-version-notification.6eb83b8a.svg",
    "revision": null
  },
  {
    "url": "/img/noWorkloads.64d40979.svg",
    "revision": null
  },
  {
    "url": "/img/no_agents.48bad52f.svg",
    "revision": null
  },
  {
    "url": "/img/no_cluster.42e54e92.svg",
    "revision": null
  },
  {
    "url": "/img/no_data.e8161842.svg",
    "revision": null
  },
  {
    "url": "/img/no_results_found.3692c8f8.svg",
    "revision": null
  },
  {
    "url": "/img/not-selected-completed.6c0fd4ea.svg",
    "revision": null
  },
  {
    "url": "/img/not-selected-not-completed.babd1ccd.svg",
    "revision": null
  },
  {
    "url": "/img/notification_warning.6059a8d4.svg",
    "revision": null
  },
  {
    "url": "/img/profile-lines.9b823ccc.svg",
    "revision": null
  },
  {
    "url": "/img/selected-completed.48ffc7fc.svg",
    "revision": null
  },
  {
    "url": "/img/selected-not-completed.64aef05b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-0.1a4ebf51.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-0.7a236646.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-0.7bdaf668.7bdaf668.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-0.9de04167.9de04167.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-1.5e045f2b.5e045f2b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-1.67aad39b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-1.eaf3b238.eaf3b238.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-1.f770ad1b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-10.3d33d7d9.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-10.eec31cf4.eec31cf4.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-10.f0211d6b.f0211d6b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-10.fc062da0.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-11.88ebc9a8.88ebc9a8.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-11.c5c76454.c5c76454.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-11.e46c2aad.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-11.ecb7555d.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-12.4083c40f.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-12.9bc96b32.9bc96b32.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-12.bac01b74.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-12.c77c9597.c77c9597.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-13.7870a35f.7870a35f.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-13.827dbccc.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-13.c202e5fd.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-13.e03ea615.e03ea615.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-14.32e671af.32e671af.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-14.8dfba68d.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-14.98f73a0b.98f73a0b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-14.c8ae8341.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-15.42145405.42145405.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-15.64768b6b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-15.917accea.917accea.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-15.d16fe624.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-16.0aba0a5b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-16.2b9b26fe.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-16.b511637b.b511637b.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-16.b7ecf90c.b7ecf90c.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-17.25980659.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-17.31656ce5.31656ce5.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-17.7457dbad.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-17.a0af8d92.a0af8d92.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-18.36464596.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-18.587fc92c.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-18.7072b1ef.7072b1ef.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-18.a1df1a59.a1df1a59.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-19.0c1cfb9a.0c1cfb9a.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-19.394a4a5e.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-2.5f71820a.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-2.8d595347.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-2.9fbba751.9fbba751.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-2.be02dea0.be02dea0.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-20.66d3ab08.66d3ab08.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-20.c905f9b6.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-3.3885dab8.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-3.488deb15.488deb15.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-3.5f60f631.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-3.96991de7.96991de7.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-4.6dfd7ed0.6dfd7ed0.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-4.aecdb7f7.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-4.bb2fcd4f.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-4.fd8d78d0.fd8d78d0.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-5.38c0c501.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-5.6e988b16.6e988b16.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-5.9f1eeac8.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-5.b8d9077e.b8d9077e.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-6.0d1020cd.0d1020cd.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-6.29224965.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-6.29600fd8.29600fd8.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-6.a4c20dc4.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-7.0c3ffe93.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-7.4c9f7a34.4c9f7a34.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-7.7a21ee09.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-7.8f5a870d.8f5a870d.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-8.435d92a4.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-8.c6af16e5.c6af16e5.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-8.ea9d5545.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-8.fb1a0d46.fb1a0d46.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-9.11bb513c.11bb513c.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-9.144a4b36.144a4b36.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-9.1d81d043.svg",
    "revision": null
  },
  {
    "url": "/img/unicons-9.842bbf18.svg",
    "revision": null
  },
  {
    "url": "/img/user-avatar.9a4d29ae.svg",
    "revision": null
  },
  {
    "url": "/img/white_logo.39739122.svg",
    "revision": null
  },
  {
    "url": "/index.html",
    "revision": "b4481301f9731f271913d1b9c7daa604"
  },
  {
    "url": "/js/10.e9c74325.js",
    "revision": null
  },
  {
    "url": "/js/1011.a83496a2.js",
    "revision": null
  },
  {
    "url": "/js/1252.c107444f.js",
    "revision": null
  },
  {
    "url": "/js/1307.5808ad34.js",
    "revision": null
  },
  {
    "url": "/js/1343.b0c45f20.js",
    "revision": null
  },
  {
    "url": "/js/1723.b61dfcb1.js",
    "revision": null
  },
  {
    "url": "/js/178.d8f47fdd.js",
    "revision": null
  },
  {
    "url": "/js/1840.3322f5b4.js",
    "revision": null
  },
  {
    "url": "/js/2006.21a5945d.js",
    "revision": null
  },
  {
    "url": "/js/2128.811a2894.js",
    "revision": null
  },
  {
    "url": "/js/2134.0b0e5332.js",
    "revision": null
  },
  {
    "url": "/js/2286.9a9204ea.js",
    "revision": null
  },
  {
    "url": "/js/2335.7c011d13.js",
    "revision": null
  },
  {
    "url": "/js/2429.fee73d65.js",
    "revision": null
  },
  {
    "url": "/js/2641.56d15b36.js",
    "revision": null
  },
  {
    "url": "/js/2761.71a68ae7.js",
    "revision": null
  },
  {
    "url": "/js/2775.8c4d528d.js",
    "revision": null
  },
  {
    "url": "/js/3098.480c85ec.js",
    "revision": null
  },
  {
    "url": "/js/3188.0d9bdc5c.js",
    "revision": null
  },
  {
    "url": "/js/3518.4491566a.js",
    "revision": null
  },
  {
    "url": "/js/3817.ae4e70e6.js",
    "revision": null
  },
  {
    "url": "/js/3863.cd4aadfa.js",
    "revision": null
  },
  {
    "url": "/js/39.534fc406.js",
    "revision": null
  },
  {
    "url": "/js/4294.be119807.js",
    "revision": null
  },
  {
    "url": "/js/436.f577c7c5.js",
    "revision": null
  },
  {
    "url": "/js/443.18eef371.js",
    "revision": null
  },
  {
    "url": "/js/4492.cde13a72.js",
    "revision": null
  },
  {
    "url": "/js/4562.5f2e08a0.js",
    "revision": null
  },
  {
    "url": "/js/4579.b2c63c1f.js",
    "revision": null
  },
  {
    "url": "/js/4584.0216ea0f.js",
    "revision": null
  },
  {
    "url": "/js/4639.54ad58bc.js",
    "revision": null
  },
  {
    "url": "/js/4806.e170f5c6.js",
    "revision": null
  },
  {
    "url": "/js/4943.42230aba.js",
    "revision": null
  },
  {
    "url": "/js/4969.3e938286.js",
    "revision": null
  },
  {
    "url": "/js/4999.4f97f405.js",
    "revision": null
  },
  {
    "url": "/js/5005.12a6cefb.js",
    "revision": null
  },
  {
    "url": "/js/5161.3033ed4a.js",
    "revision": null
  },
  {
    "url": "/js/5194.8d762f6c.js",
    "revision": null
  },
  {
    "url": "/js/5641.4f4214a0.js",
    "revision": null
  },
  {
    "url": "/js/5668.cc98ef14.js",
    "revision": null
  },
  {
    "url": "/js/5722.c6a3a5df.js",
    "revision": null
  },
  {
    "url": "/js/5861.f6521c8a.js",
    "revision": null
  },
  {
    "url": "/js/5888.3448193f.js",
    "revision": null
  },
  {
    "url": "/js/6035.08c821e9.js",
    "revision": null
  },
  {
    "url": "/js/6114.fc2b2980.js",
    "revision": null
  },
  {
    "url": "/js/6171.298981a3.js",
    "revision": null
  },
  {
    "url": "/js/6352.385c791d.js",
    "revision": null
  },
  {
    "url": "/js/6375.954aea8f.js",
    "revision": null
  },
  {
    "url": "/js/6438.20cd3f43.js",
    "revision": null
  },
  {
    "url": "/js/6451.b6c73d03.js",
    "revision": null
  },
  {
    "url": "/js/6607.4f1d5d46.js",
    "revision": null
  },
  {
    "url": "/js/6644.2ae12cd0.js",
    "revision": null
  },
  {
    "url": "/js/668.adad603c.js",
    "revision": null
  },
  {
    "url": "/js/6693.f5df1733.js",
    "revision": null
  },
  {
    "url": "/js/684.989e9c90.js",
    "revision": null
  },
  {
    "url": "/js/7100.2a964b34.js",
    "revision": null
  },
  {
    "url": "/js/7141.ccd46ee6.js",
    "revision": null
  },
  {
    "url": "/js/7289.7ce0ce2e.js",
    "revision": null
  },
  {
    "url": "/js/7305.1ad755e6.js",
    "revision": null
  },
  {
    "url": "/js/7324.613ea540.js",
    "revision": null
  },
  {
    "url": "/js/734.abc6539e.js",
    "revision": null
  },
  {
    "url": "/js/7353.0d0f5d16.js",
    "revision": null
  },
  {
    "url": "/js/7420.bff82207.js",
    "revision": null
  },
  {
    "url": "/js/7451.45a10705.js",
    "revision": null
  },
  {
    "url": "/js/7759.a9921ad0.js",
    "revision": null
  },
  {
    "url": "/js/8095.888622cc.js",
    "revision": null
  },
  {
    "url": "/js/8134.4ae5635b.js",
    "revision": null
  },
  {
    "url": "/js/8609.f3c821aa.js",
    "revision": null
  },
  {
    "url": "/js/8617.a9220b92.js",
    "revision": null
  },
  {
    "url": "/js/8815.6cf6c007.js",
    "revision": null
  },
  {
    "url": "/js/8819.39ab2cb0.js",
    "revision": null
  },
  {
    "url": "/js/9045.2454c5c5.js",
    "revision": null
  },
  {
    "url": "/js/9307.f3913eae.js",
    "revision": null
  },
  {
    "url": "/js/9341.1f5a3b56.js",
    "revision": null
  },
  {
    "url": "/js/9833.f39e8dc2.js",
    "revision": null
  },
  {
    "url": "/js/9919.7fc47b2f.js",
    "revision": null
  },
  {
    "url": "/js/9949.df694506.js",
    "revision": null
  },
  {
    "url": "/js/9985.0b8a7cf5.js",
    "revision": null
  },
  {
    "url": "/js/app.ece13643.js",
    "revision": null
  },
  {
    "url": "/js/chunk-vendors.f9c6405a.js",
    "revision": null
  },
  {
    "url": "/js/img/icomoon.3b86271e.svg",
    "revision": "bd8e648917e14d1f79e732b6d6e1bb37"
  },
  {
    "url": "/js/img/incredicon.640f37b0.svg",
    "revision": "5ac4e4e5f2da3ac2bd03e62f4b6e281c"
  },
  {
    "url": "/js/img/unicons-0.7bdaf668.svg",
    "revision": "e3df73aa416bfff18f2ad1a5b89c66a3"
  },
  {
    "url": "/js/img/unicons-0.9de04167.svg",
    "revision": "43776f8712b002d881b42ed13b2c6064"
  },
  {
    "url": "/js/img/unicons-1.5e045f2b.svg",
    "revision": "706b5e5c088c0738e9c8a698a41d336c"
  },
  {
    "url": "/js/img/unicons-1.eaf3b238.svg",
    "revision": "6894bd8ee75ac6e8554176bf9d6fb0f5"
  },
  {
    "url": "/js/img/unicons-10.eec31cf4.svg",
    "revision": "af20d281900d788c14bf904daa89696f"
  },
  {
    "url": "/js/img/unicons-10.f0211d6b.svg",
    "revision": "fc3da9e85f2241076bdf4a845734659b"
  },
  {
    "url": "/js/img/unicons-11.88ebc9a8.svg",
    "revision": "c2764a202fd655e9016b41d1e249fc3c"
  },
  {
    "url": "/js/img/unicons-11.c5c76454.svg",
    "revision": "25fab5c268c2f5f14fd99347865f2073"
  },
  {
    "url": "/js/img/unicons-12.9bc96b32.svg",
    "revision": "030eeebc7baa5ad4d9a210ee00321008"
  },
  {
    "url": "/js/img/unicons-12.c77c9597.svg",
    "revision": "182e1d2cd9edc4aaa56416ac3c36bcaf"
  },
  {
    "url": "/js/img/unicons-13.7870a35f.svg",
    "revision": "cab231b204e740a9b2a9cf88bb7d229d"
  },
  {
    "url": "/js/img/unicons-13.e03ea615.svg",
    "revision": "c287597bce6d1f391aaf87139fa608c4"
  },
  {
    "url": "/js/img/unicons-14.32e671af.svg",
    "revision": "b0053e2ee56bdcb1622e6b9281e12333"
  },
  {
    "url": "/js/img/unicons-14.98f73a0b.svg",
    "revision": "41ac0bdd1953b58a267d04346296724a"
  },
  {
    "url": "/js/img/unicons-15.42145405.svg",
    "revision": "42759d3b0042666858a6c77a00b05b43"
  },
  {
    "url": "/js/img/unicons-15.917accea.svg",
    "revision": "ad51ea537fb348272bc82950d117d017"
  },
  {
    "url": "/js/img/unicons-16.b511637b.svg",
    "revision": "a8bde1322a21b17a59fd00ae265c38e8"
  },
  {
    "url": "/js/img/unicons-16.b7ecf90c.svg",
    "revision": "9d5aa90ce0fae2fd699732d1be92c569"
  },
  {
    "url": "/js/img/unicons-17.31656ce5.svg",
    "revision": "e986e14c26e45d0daf3a3ee5a4e3320a"
  },
  {
    "url": "/js/img/unicons-17.a0af8d92.svg",
    "revision": "5a6fe99483166fd10ebec5fc193387fd"
  },
  {
    "url": "/js/img/unicons-18.7072b1ef.svg",
    "revision": "370e06720208dcbe9b7e349251d9dfb7"
  },
  {
    "url": "/js/img/unicons-18.a1df1a59.svg",
    "revision": "8b6328f1a6a69029d06bf045faa45fed"
  },
  {
    "url": "/js/img/unicons-19.0c1cfb9a.svg",
    "revision": "f45e923f35cabf0c84c11bb7a499f5e0"
  },
  {
    "url": "/js/img/unicons-2.9fbba751.svg",
    "revision": "ed3cd426378ccbbb4439502a609e6075"
  },
  {
    "url": "/js/img/unicons-2.be02dea0.svg",
    "revision": "d284f6c7215081b9f1d661463441c714"
  },
  {
    "url": "/js/img/unicons-20.66d3ab08.svg",
    "revision": "55b388ceced1d20f76e97e841a670e8e"
  },
  {
    "url": "/js/img/unicons-3.488deb15.svg",
    "revision": "6fc77b94c1f0c6c1c3e3a980c496106d"
  },
  {
    "url": "/js/img/unicons-3.96991de7.svg",
    "revision": "a998949cc9ea517defcc9e710584da44"
  },
  {
    "url": "/js/img/unicons-4.6dfd7ed0.svg",
    "revision": "1dd27a29f96b46c71d10506e4ef23467"
  },
  {
    "url": "/js/img/unicons-4.fd8d78d0.svg",
    "revision": "25be70f496d55c725b8a91343055f5de"
  },
  {
    "url": "/js/img/unicons-5.6e988b16.svg",
    "revision": "a08eacf7b7dd8be75ddebaa7d3646e3f"
  },
  {
    "url": "/js/img/unicons-5.b8d9077e.svg",
    "revision": "aa3ed11249e0d2cebdf7de4a4c0d7a1c"
  },
  {
    "url": "/js/img/unicons-6.0d1020cd.svg",
    "revision": "7c99bba59afef65c8d76595fd9757cfd"
  },
  {
    "url": "/js/img/unicons-6.29600fd8.svg",
    "revision": "b2507a0f9b723a5b8e06493783f36301"
  },
  {
    "url": "/js/img/unicons-7.4c9f7a34.svg",
    "revision": "d69d5f75a7e594d50685835a882081f3"
  },
  {
    "url": "/js/img/unicons-7.8f5a870d.svg",
    "revision": "da2cf7ee992dd6d4ef9ff1f491910a43"
  },
  {
    "url": "/js/img/unicons-8.c6af16e5.svg",
    "revision": "29f7bc235d1b33c1bad8dd092791607c"
  },
  {
    "url": "/js/img/unicons-8.fb1a0d46.svg",
    "revision": "539e4047d2065a126df9cebe957454a4"
  },
  {
    "url": "/js/img/unicons-9.11bb513c.svg",
    "revision": "36df3d6fee6fdf15a8670f175d6830a3"
  },
  {
    "url": "/js/img/unicons-9.144a4b36.svg",
    "revision": "5cecee6c653b0a9c3dad1c6af0478025"
  },
  {
    "url": "/manifest.json",
    "revision": "28256fac00f80c8144a409c0894eb46f"
  },
  {
    "url": "/robots.txt",
    "revision": "735ab4f94fbcd57074377afca324c813"
  }
], {});








